package com.nikolastojiljkovic.dotty.compiler.shared

import io.circe.Codec

case class CompilationRange(start: CompilationPoint, end: CompilationPoint) derives Codec.AsObject
